import React from "react";
import { Link } from "react-router-dom";
import MinorAilments from "../components/MinorAilments/MinorAilments";
import Footer from "../components/Footer";

function ConsultationPage() {
  return (
    <div className="page-container">
      <div className="content-wrap">
        <MinorAilments />
      </div>
    </div>
  );
}

export default ConsultationPage;
